import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { fetchPlayerStatistics, statisticsId } from "../../../../store/actions/statisticActions";
import { IDType } from "../../../../config/types";
import { PlayerStatisticsListV2 } from "../../../../client/api";

type LeagueStatisticsPlayerProps = {
  leagueId: IDType;
  onDataLoaded?: (data: PlayerStatisticsListV2) => void;
  isPremiumUser?: boolean;
};

const LeagueStatisticsPlayer: React.FC<LeagueStatisticsPlayerProps> = ({
                                                                         leagueId,
                                                                         onDataLoaded,
                                                                         isPremiumUser
                                                                       }) => {
  const dispatch = useDispatch<AppDispatch>();
  const tried = useRef(false);

  const playerStats = useSelector((state: RootState) => {
    const key = statisticsId(leagueId);
    return state.statistics.playerStats[key];
  });

  const loading = useSelector((state: RootState) => state.statistics.status === "loading");


  useEffect(() => {
    if (leagueId && !playerStats && !tried.current && !loading) {
      tried.current = true;
      fetchPlayerStatistics(dispatch, leagueId);
    }
  }, [leagueId, playerStats, loading, dispatch, isPremiumUser]);

  useEffect(() => {
    if (playerStats && onDataLoaded) {
      onDataLoaded(playerStats.response);
    }
  }, [playerStats, onDataLoaded, isPremiumUser]);

  return null;
};

export default LeagueStatisticsPlayer;

